/**
 * @fileoverview gRPC-Web generated client stub for witbooking.loyalty.brand.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.loyalty = {};
proto.witbooking.loyalty.brand = {};
proto.witbooking.loyalty.brand.v1 = require('./brand_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.brand.v1.BrandAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.brand.v1.BrandAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.brand.v1.GetBrandRequest,
 *   !proto.witbooking.loyalty.brand.v1.GetBrandResponse>}
 */
const methodDescriptor_BrandAPI_GetBrand = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.brand.v1.BrandAPI/GetBrand',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.brand.v1.GetBrandRequest,
  proto.witbooking.loyalty.brand.v1.GetBrandResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.GetBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.GetBrandResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.brand.v1.GetBrandRequest,
 *   !proto.witbooking.loyalty.brand.v1.GetBrandResponse>}
 */
const methodInfo_BrandAPI_GetBrand = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.brand.v1.GetBrandResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.GetBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.GetBrandResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.brand.v1.GetBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.brand.v1.GetBrandResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.brand.v1.GetBrandResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.brand.v1.BrandAPIClient.prototype.getBrand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/GetBrand',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_GetBrand,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.brand.v1.GetBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.brand.v1.GetBrandResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.brand.v1.BrandAPIPromiseClient.prototype.getBrand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/GetBrand',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_GetBrand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.brand.v1.CreateBrandRequest,
 *   !proto.witbooking.loyalty.brand.v1.CreateBrandResponse>}
 */
const methodDescriptor_BrandAPI_CreateBrand = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.brand.v1.BrandAPI/CreateBrand',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.brand.v1.CreateBrandRequest,
  proto.witbooking.loyalty.brand.v1.CreateBrandResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.CreateBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.CreateBrandResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.brand.v1.CreateBrandRequest,
 *   !proto.witbooking.loyalty.brand.v1.CreateBrandResponse>}
 */
const methodInfo_BrandAPI_CreateBrand = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.brand.v1.CreateBrandResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.CreateBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.CreateBrandResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.brand.v1.CreateBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.brand.v1.CreateBrandResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.brand.v1.CreateBrandResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.brand.v1.BrandAPIClient.prototype.createBrand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/CreateBrand',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_CreateBrand,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.brand.v1.CreateBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.brand.v1.CreateBrandResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.brand.v1.BrandAPIPromiseClient.prototype.createBrand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/CreateBrand',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_CreateBrand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.brand.v1.GetBrandByTickerRequest,
 *   !proto.witbooking.loyalty.brand.v1.GetBrandByTickerResponse>}
 */
const methodDescriptor_BrandAPI_GetBrandByTicker = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.brand.v1.BrandAPI/GetBrandByTicker',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.brand.v1.GetBrandByTickerRequest,
  proto.witbooking.loyalty.brand.v1.GetBrandByTickerResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.GetBrandByTickerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.GetBrandByTickerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.brand.v1.GetBrandByTickerRequest,
 *   !proto.witbooking.loyalty.brand.v1.GetBrandByTickerResponse>}
 */
const methodInfo_BrandAPI_GetBrandByTicker = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.brand.v1.GetBrandByTickerResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.GetBrandByTickerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.GetBrandByTickerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.brand.v1.GetBrandByTickerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.brand.v1.GetBrandByTickerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.brand.v1.GetBrandByTickerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.brand.v1.BrandAPIClient.prototype.getBrandByTicker =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/GetBrandByTicker',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_GetBrandByTicker,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.brand.v1.GetBrandByTickerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.brand.v1.GetBrandByTickerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.brand.v1.BrandAPIPromiseClient.prototype.getBrandByTicker =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/GetBrandByTicker',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_GetBrandByTicker);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.brand.v1.UpdateBrandRequest,
 *   !proto.witbooking.loyalty.brand.v1.UpdateBrandResponse>}
 */
const methodDescriptor_BrandAPI_UpdateBrand = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.brand.v1.BrandAPI/UpdateBrand',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.brand.v1.UpdateBrandRequest,
  proto.witbooking.loyalty.brand.v1.UpdateBrandResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.UpdateBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.UpdateBrandResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.brand.v1.UpdateBrandRequest,
 *   !proto.witbooking.loyalty.brand.v1.UpdateBrandResponse>}
 */
const methodInfo_BrandAPI_UpdateBrand = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.brand.v1.UpdateBrandResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.UpdateBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.UpdateBrandResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.brand.v1.UpdateBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.brand.v1.UpdateBrandResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.brand.v1.UpdateBrandResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.brand.v1.BrandAPIClient.prototype.updateBrand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/UpdateBrand',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_UpdateBrand,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.brand.v1.UpdateBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.brand.v1.UpdateBrandResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.brand.v1.BrandAPIPromiseClient.prototype.updateBrand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/UpdateBrand',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_UpdateBrand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.brand.v1.DeleteBrandRequest,
 *   !proto.witbooking.loyalty.brand.v1.DeleteBrandResponse>}
 */
const methodDescriptor_BrandAPI_DeleteBrand = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.brand.v1.BrandAPI/DeleteBrand',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.brand.v1.DeleteBrandRequest,
  proto.witbooking.loyalty.brand.v1.DeleteBrandResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.DeleteBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.DeleteBrandResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.brand.v1.DeleteBrandRequest,
 *   !proto.witbooking.loyalty.brand.v1.DeleteBrandResponse>}
 */
const methodInfo_BrandAPI_DeleteBrand = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.brand.v1.DeleteBrandResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.DeleteBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.DeleteBrandResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.brand.v1.DeleteBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.brand.v1.DeleteBrandResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.brand.v1.DeleteBrandResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.brand.v1.BrandAPIClient.prototype.deleteBrand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/DeleteBrand',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_DeleteBrand,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.brand.v1.DeleteBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.brand.v1.DeleteBrandResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.brand.v1.BrandAPIPromiseClient.prototype.deleteBrand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/DeleteBrand',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_DeleteBrand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierRequest,
 *   !proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierResponse>}
 */
const methodDescriptor_BrandAPI_RecalculateCustomersTier = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.brand.v1.BrandAPI/RecalculateCustomersTier',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierRequest,
  proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierRequest,
 *   !proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierResponse>}
 */
const methodInfo_BrandAPI_RecalculateCustomersTier = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.brand.v1.BrandAPIClient.prototype.recalculateCustomersTier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/RecalculateCustomersTier',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_RecalculateCustomersTier,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.brand.v1.RecalculateCustomersTierResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.brand.v1.BrandAPIPromiseClient.prototype.recalculateCustomersTier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/RecalculateCustomersTier',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_RecalculateCustomersTier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.brand.v1.ListBrandsRequest,
 *   !proto.witbooking.loyalty.brand.v1.ListBrandsResponse>}
 */
const methodDescriptor_BrandAPI_ListBrands = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.brand.v1.BrandAPI/ListBrands',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.brand.v1.ListBrandsRequest,
  proto.witbooking.loyalty.brand.v1.ListBrandsResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.ListBrandsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.ListBrandsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.brand.v1.ListBrandsRequest,
 *   !proto.witbooking.loyalty.brand.v1.ListBrandsResponse>}
 */
const methodInfo_BrandAPI_ListBrands = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.brand.v1.ListBrandsResponse,
  /**
   * @param {!proto.witbooking.loyalty.brand.v1.ListBrandsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.brand.v1.ListBrandsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.brand.v1.ListBrandsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.brand.v1.ListBrandsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.brand.v1.ListBrandsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.brand.v1.BrandAPIClient.prototype.listBrands =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/ListBrands',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_ListBrands,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.brand.v1.ListBrandsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.brand.v1.ListBrandsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.brand.v1.BrandAPIPromiseClient.prototype.listBrands =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.brand.v1.BrandAPI/ListBrands',
      request,
      metadata || {},
      methodDescriptor_BrandAPI_ListBrands);
};


module.exports = proto.witbooking.loyalty.brand.v1;

